import { render } from "./UpdateUserModal.vue?vue&type=template&id=2f79f70b&scoped=true"
import script from "./UpdateUserModal.vue?vue&type=script&lang=js"
export * from "./UpdateUserModal.vue?vue&type=script&lang=js"

import "./UpdateUserModal.vue?vue&type=style&index=0&id=2f79f70b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f79f70b"]])

export default __exports__